import { couponAnnuityType, couponType } from "../../helpers/data-constants";

export function calculateRisk(risk1, risk2, risk3) {
    let risk = risk1 + risk2 + risk3;
    if(risk){
        var count = (risk.match(/Низкий/g) || []).length;
        return count > 1;
    }
    return undefined;

}

export const getCouponType = (stateCouponType) => {
    const foundEntry = Object.entries(couponAnnuityType).find(
        ([_, value]) => value === stateCouponType
      );
      
      if (foundEntry) {
        const [key] = foundEntry;
        return couponType[key];
      }
      
      return couponType.SHORT_TERM;
};